import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IdexService } from '../../../idex.service';
import { RegisterSignatureComponent } from '../../register-signature/register-signature.component';
import { ConfirmCertificateComponent } from '../../confirm-certificate/confirm-certificate.component';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Toast } from 'app/shared/toast/toast';
import { Subject } from 'rxjs';
import { EformService } from 'app/e-form/service/eform.service';

declare var $: any;

const signToolAction = ['signature', 'initSignature', 'name', 'date', 'text', 'image', 'checkbox'] as const;
type SignToolAction = typeof signToolAction[number];

@Component({
   selector: 'app-tools',
   templateUrl: './tools.component.html',
   styleUrls: ['./tools.component.css']
})
export class ToolsComponent implements OnInit, OnChanges {
   // public isHideSigner:boolean=false;
   @Input() typeName: any;
   @Input() apvLevel: any;
   @Input() signMenuClick: any;
   @Input() signMenuDrag: Subject<string>;
   @Input() colors: any;
   @Input() hasSignature: boolean;
   @Input() hasInitial: boolean;
   @Input() profile: any;
   @Input() imageSignatureOriginal: any;
   @Input() imageInitOriginal: any;
   @Input() fieldName: any;
   @Input() mimeType: any;
   @Input() isForm: boolean;
   @Input() selectedSignerList: any;
   @Output() signerChange = new EventEmitter<any>();
   @Output() updateSignatureEvent = new EventEmitter<any>();
   @Output() updateSignatureInclude= new EventEmitter<any>();
   @Output() UpdateInitialEvent = new EventEmitter<any>();
   @Output() setSigner = new EventEmitter<any>();
   isExpanded = true;
   flag = true;
   public signers = [];
   public myStyle;
   public selected = 0;
   private _actionNeedToSign = 'Need to Sign';
   private _actionExternalSign = 'External Sign';
   private _indexSelected = 0;
   private registerSignDialog: MatDialogRef<RegisterSignatureComponent>;
   public includeName: any;
   public includeDate: any;
   private certDefault = 0;
   listCert: any[];

   private confrimCertDialog: MatDialogRef<ConfirmCertificateComponent>;

   /**
    * Preload image icon to be used as a mouse cursor icon when dragging tools.
    *
    * Without this, the image icon may not be loaded and the cursor will use the default icon instead. See ZE-2704.
    */
   private preloadedIcon: { [K in SignToolAction]?: HTMLImageElement } = {};

   constructor(public service: IdexService, private dialog: MatDialog, private dialogCert: MatDialog, private toast: Toast, private eFormService: EformService) {
      this.eFormService.changeFlowRecipientTrigger.subscribe(data => {
         if (data.selectedSignerList) {
            for (const item of data.selectedSignerList) {
               const foundSigner = data.signers.find(x => x.signerEmail === item.signer);
               this.eFormService.removeGroup.subscribe(isGroupRemoved => {
                  if (isGroupRemoved) {
                     this.resetColor(this.fieldName); // ZE-5244
                  }
               });
               if (!foundSigner) {
                  this.setCurrentValue(item.fieldName);
                  this.eFormService.changeSignatureBackground.next(item.fieldName);
                  const index = this.selectedSignerList.findIndex(x => x.fieldName === item.fieldName);
                  if (index !== -1) {
                     this.selectedSignerList[index - 1] = '';  // ZE-5248
                  }
               } else {
                  const index = data.signers.findIndex(x => x.signerEmail === item.signer && x.stepOrder === item.stepOrder);
                  const element = document.getElementById('holder' + item.fieldName);
                  if (element) {
                     element.style.backgroundColor = this.colors[index];
                     element.style.opacity = '0.5';
                  }
               }
            }
         }
      })
   }

   ngOnInit() {
      if (this.typeName !== 'sign') {
         this.setSigners(this.apvLevel);
         if (this.isForm) {
            if (this.typeName !== 'startFlow' && this.typeName !== 'task') {
               this.signerChange.emit({ index: this.selected, signer: this.signers[this.selected] });
            }
         } else {
            this.signerChange.emit({ index: this.selected, signer: this.signers[this.selected] });
         }
      }
      this.service.get('cert/list')
         .subscribe((data: any) => {
            if (data) {
               this.listCert = data;
            }
         }, error => {
            this.toast.error(error.massage);
      });

      // Preloading each draggable tool's icon
      for (const action of signToolAction) {
         this.preloadedIcon[action] = createImageDOM(this.getActionIconPath(action));
      }

      function createImageDOM(src?: string) {
         let element = new Image();
         element.src = src ?? "";
         return element;
      }

      this.service.get('cert/default')
      .subscribe(data => {
            this.certDefault = data;
      }, error => {
         this.toast.error(error.massage);
      });
   }

   setSigners(apvLevel) {
      this.signers = [];
      for (const signers of apvLevel) {
         for (const signer of signers.signerList) {
            if (signer.action === this._actionNeedToSign || signer.action === this._actionExternalSign) {
               this.signers.push(signer);
            }
         }
      }
      if (this.isForm) {
         this.signers.unshift({ signerEmail: '', action: 'clear', nameShow: '' });
         if ( this.colors[0] !== 'null') {
            this.colors.unshift('null');
         }
      } else {
         if ( this.colors[0] === 'null') {
            this.colors.shift()
         }
      }
      if (this.fieldName) {
         this.setCurrentValue(this.fieldName);
      } else {
         this.setSigner.emit();
      }
      this.eFormService.changeFlowRecipientTrigger.next({signers: this.signers, selectedSignerList: this.selectedSignerList});
   }

   setExpand(isExpand: boolean) {
      this.isExpanded = isExpand;
   }
   onHideAndShowSigner(flag: boolean) {
      this.flag = flag;
   }
   onSignerChange(index, signer?) {
      this._indexSelected = index;
      let signerTmp;
      if (signer) {
         signerTmp = signer;
      } else {
         signerTmp = this.signers[index];
      }
      this.signerChange.emit({ index: index, signer: signerTmp, color: this.colors[index] });
   }

   addNewSigner(apvLevel) {
      this.signers = [];
      for (const signers of apvLevel) {
         for (const signer of signers.signerList) {
            if (signer.action === this._actionNeedToSign || signer.action === this._actionExternalSign) {
               this.signers.push(signer);
            }
         }
      }
      return { index: this.selected, signer: this.signers[this.selected] };
   }

   private getActionIconPath(action: SignToolAction) {
      switch (action) {
         case 'signature':
            return 'assets/icons/sign-icon.png';
         case 'initSignature':
            return 'assets/icons/sign-icon.png';
         case 'name':
            return 'assets/icons/man-user.png';
         case 'date':
            return 'assets/icons/calendar-page-empty.png';
         case 'text':
            return 'assets/icons/free-text.png';
         case 'image':
            return 'assets/icons/img-attach.png';
         case 'checkbox':
            return 'assets/icons/checkbox.png';
      }
   }

   testDrag($event: DragEvent, action: SignToolAction) {
      this.signMenuDrag.next(action);
      $event.dataTransfer.setDragImage(this.preloadedIcon[action], -10, -10);
      const target = $event.target as HTMLElement;
      $event.dataTransfer.setData('text/plain', target.id);
   }

   onDragOver($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.dataTransfer.effectAllowed = 'none';
      $event.dataTransfer.dropEffect = 'none';
   }

   onClickSignMenu($event, type) {
      // check case when no signature click sign menu call dialog update
      let ischeckCert = true;

      if (this.certDefault === 0 && this.listCert === undefined) {
         ischeckCert = false;
      }
      if ((this.hasSignature && type === 'signature') || (this.typeName !== 'signTask' && this.typeName !== 'sign' && type === 'signature')) {
         this.signMenuClick.next('signature');
         this.updateSignatureInclude.emit($event);
      } else if ((this.hasInitial && type === 'initSignature') || (this.typeName !== 'signTask' && this.typeName !== 'sign' && type === 'initSignature')) {
         this.signMenuClick.next('initSignature');
      } else {

         if (ischeckCert !== false) {
            this.openUpdateSignature(this.profile.signatureId, this.profile.initialId, this.profile.fName + ' ' + this.profile.lName, type);
         }
      }
      if (ischeckCert === false) {
         this.confrimCertDialog = this.dialogCert.open(ConfirmCertificateComponent, {
            autoFocus: false,
            disableClose: true,
            data: this
         });
      }
   }

   openUpdateSignature(signatureId: any, initialId: any, fullName: any, type: any) {
      this.registerSignDialog = this.dialog.open(RegisterSignatureComponent, {
         autoFocus: false,
         disableClose: true,
         data: this
      });
      this.registerSignDialog.componentInstance.signatureId = signatureId;
      this.registerSignDialog.componentInstance.initialId = initialId;
      this.registerSignDialog.componentInstance.fullNameValue = fullName;
      this.registerSignDialog.componentInstance.includeName = this.profile.includeName;
      this.registerSignDialog.componentInstance.includeDate = this.profile.includeDate;
      this.registerSignDialog.componentInstance.hasSignature = this.hasSignature;
      this.registerSignDialog.componentInstance.hasInitial = this.hasInitial;
      if (type === 'signature') {
         this.registerSignDialog.componentInstance.registerInitialize = true;
      } else if (type === 'initSignature') {
         this.registerSignDialog.componentInstance.registerSignature = true;
      }
      if (!this.hasSignature) {
         this.registerSignDialog.componentInstance.imageSignatureOriginal = 'assets/images/no_signature.png';
      } else {
         this.registerSignDialog.componentInstance.imageSignatureOriginal = this.imageSignatureOriginal;
      }
      if (!this.hasInitial) {
         this.registerSignDialog.componentInstance.imageInitOriginal = 'assets/images/no_initials.png';
      } else {
         this.registerSignDialog.componentInstance.imageInitOriginal = this.imageInitOriginal;
      }

      this.registerSignDialog.afterClosed().subscribe(result => {
         if (result) {
            this.service.getProfile()
               .subscribe((data: any) => {
                  this.hasSignature = data.hasSignature;
                  this.hasInitial = data.hasInitial;
               });
            this.updateSignatureEvent.emit(true);
            this.UpdateInitialEvent.emit(true);
         }
      });
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes.fieldName) {
         if (!this.signers.length) {
            this.setSigners(this.apvLevel);
            this.setCurrentValue(changes.fieldName.currentValue);
         } else {
            this.setCurrentValue(changes.fieldName.currentValue);
         }
      }
   }

   setCurrentValue(fieldName: any) {
      if (fieldName && this.selectedSignerList.length) {
         let index = this.selectedSignerList.findIndex((element) => element.fieldName === fieldName);
         if (index !== -1) {
            let signerIndex = this.signers.findIndex((element) => (element.signerEmail === this.selectedSignerList[index].signer) &&
            (element.stepOrder === this.selectedSignerList[index].stepOrder));
            if (signerIndex !== -1) {
               this.selected = signerIndex;
               this.onSignerChange(signerIndex, this.signers.find((element) => (element.signerEmail === this.selectedSignerList[index].signer &&
                  (element.stepOrder === this.selectedSignerList[index].stepOrder))));
            } else {
               this.selected = 0;
               let element = document.getElementById('holder' + fieldName);
               if (element) {
                  element.style.backgroundColor = '#ffffff';
                  element.style.opacity = '1';
               }
            }
         } else {
            this.selected = 0;
         }
      }
   }
   resetColor(fieldName: any) { // ZE-5244
      Array.from({ length: fieldName }, (_, i) => i + 1).forEach(i => {
        const element = document.getElementById(`holder${i}`) as HTMLElement;
        this.selectedSignerList[i - 1] = '';
        if (element) {
          element.style.backgroundColor = '#ffffff';
          element.style.opacity = '1';
        }
      });
    }
}
